import { Search } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { SidebarGroup, SidebarGroupContent, SidebarInput } from '@/components/ui/sidebar';

export function SearchTags({
    search,
    setSearch,
    tabValue,
    onOpenAdvancedSearch,
    ...props
}: React.ComponentProps<'form'> & {
    search: string;
    setSearch: (search: string) => void;
    tabValue: 'tags' | 'books';
    onOpenAdvancedSearch?: () => void;
}) {
    return (
        <form {...props}>
            <SidebarGroup className="py-0">
                <SidebarGroupContent>
                    <div className="flex items-center gap-2">
                        <div className="relative flex-1">
                            <Label
                                htmlFor="search"
                                className="sr-only"
                            >
                                Search
                            </Label>
                            <SidebarInput
                                id="search"
                                placeholder={`Search ${tabValue === 'tags' ? 'tags' : 'books'}...`}
                                className="pl-8"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                type="search"
                                name="search"
                            />
                            <Search className="pointer-events-none absolute top-1/2 left-2 size-4 -translate-y-1/2 opacity-50 select-none" />
                        </div>
                        {onOpenAdvancedSearch && (
                            <Button
                                type="button"
                                variant="outline"
                                size="sm"
                                onClick={onOpenAdvancedSearch}
                            >
                                Advanced
                            </Button>
                        )}
                    </div>
                </SidebarGroupContent>
            </SidebarGroup>
        </form>
    );
}
